import InspectionData from './InspectionData.container';
export default InspectionData;
